/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute = (props) => {
  const user = useSelector((state) => state.cmsAuth.user)
  return user ? <Outlet /> : <Navigate to='/admin/login' />
}
export default PrivateRoute
